import type { HttpClient } from '~/shared/api'
import type { RequestRestService } from '../RequestRestService'
import { VacanciesMainService } from '~/services/vacancies/VacanciesMainService'
import  { VacanciesFiltersService } from '~/services/vacancies/VacanciesFiltersService'
import  { VacanciesDetailService } from '~/services/vacancies/VacanciesDetailService'

export class VacanciesService {
  readonly main: VacanciesMainService
  readonly detail: VacanciesDetailService
  readonly filters: VacanciesFiltersService

  constructor(requestRest: RequestRestService, http: HttpClient) {
    this.main = new VacanciesMainService(http, requestRest)
    this.detail = new VacanciesDetailService(http)
    this.filters = new VacanciesFiltersService(http)
  }
}
